import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CookieService } from 'angular2-cookie/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http'
import { HttpModule } from '@angular/http';
import { AppRoutingModule } from './app-routing.module';
import { SuiModule } from 'ng2-semantic-ui';
import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';
import { AuthenticateComponent } from './authenticate/authenticate.component';
import { UnauthorizedComponent } from "./unauthorized/unauthorized.component";
import { AppInitService } from './app-init.service';
import { DataService } from './user-detail.service';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AttendanceStatusComponentV1 } from './attendance-status-v1/attendance-status-v1.component';
import { AttendanceStatusComponent } from './attendance-status/attendance-status.component';
import { StatusTableComponent } from './attendance-status/status-table/status-table.component';
import { FormsModule } from '@angular/forms';
import { MorningMeetingComponent } from './attendance-status/morning-meeting/morning-meeting.component';
import { StaffListResolver } from './attendance-status/stafflist-resolver.service';
import { GroupListResolver } from './attendance-status/grouplist-resolver.service';
import { TimestampTableComponent } from './attendance-status/timestamp-table/timestamp-table.component';
import { BreaktimeCebuResolver } from './breaktime-cebu/shared/breaktime-cebu.resolver';

export function initializeApp1(appInitService: AppInitService) {
    return (): Promise<any> => {
        return appInitService.Init();
    }
}
@NgModule({
    declarations: [
        AppComponent,
        AuthenticateComponent,
        UnauthorizedComponent,
        AttendanceStatusComponentV1,
        AttendanceStatusComponent,
        StatusTableComponent,
        MorningMeetingComponent,
        TimestampTableComponent,
    ],
    imports: [
        BrowserModule,
        HttpModule,
        HttpClientModule,
        AppRoutingModule,
        SuiModule,
        SharedModule,
        BrowserAnimationsModule,
        FormsModule
    ],
    providers: [
        AppInitService, DataService, BreaktimeCebuResolver,
        { provide: APP_INITIALIZER, useFactory: initializeApp1, deps: [AppInitService], multi: true },
        { provide: CookieService, useFactory: cookieServiceFactory },
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        StaffListResolver,
        GroupListResolver
    ],
    bootstrap: [AppComponent],
    exports: [AppComponent]
})
export class AppModule { }
export function cookieServiceFactory() { return new CookieService(); }
